import { uuidv4, jsonObjFromBase64 } from "./utils.js";
import { KEY } from "./constants.js";
import { usePermissionStore } from "../store/permission.js";

var receiveData = {};

export const WKWebViewJSBridge = () => {
  if (window.web) {
    return;
  }

  window.web = (function () {
    const receiveWeb = (data) => {
      var jsonObj = processWeb(data);

      // 키값 동일힐 경우 store에 허용 여부 저장
      if (jsonObj[KEY.requestIDWeb] === receiveData[KEY.requestIDWeb]) {
        usePermissionStore.getState().setIsCameraAllowed(jsonObj.result);
      } else {
        // 재요청
        requestSwift(jsonObj);
      }
    };

    // 받은 데이터 Base64 디코딩 후 JSON 객체로 변환
    const processWeb = (data) => {
      var jsonObj = jsonObjFromBase64(data);
      if (jsonObj[KEY.requestIDWeb] == null) {
        jsonObj = processJSBridge(jsonObj);
      }
      return jsonObj;
    };

    return {
      receiveWeb: function (data) {
        receiveWeb(data);
      },
      requestPermission: function (data) {
        receiveWeb(data);
      },
    };
  })();

  const processJSBridge = (jsonObj) => {
    jsonObj["result"] = true;
    jsonObj["title"] += ", processed on web";
    return jsonObj;
  };
};

const requestSwift = (param, path, callback) => {
  if (window.webkit?.messageHandlers && window.webkit.messageHandlers[path]) {
    const requestID = uuidv4();
    receiveData[KEY.requestIDWeb] = requestID;
    param[KEY.requestIDWeb] = requestID;

    // store에 요청키 저장
    usePermissionStore.getState().setWebRequestKey(requestID);

    if (callback) {
      receiveData[requestID] = callback;
    }

    const jsonString = btoa(encodeURIComponent(JSON.stringify(param)));
    window.webkit?.messageHandlers[path].postMessage(jsonString);
  }
};

export const onlyRequest = (command) => {
  requestSwift({}, command);
};

export const roundRequest = (requestData, command = "RoundRequest") => {
  const data = requestData ? requestData : {};

  requestSwift(data, command, (jsonObj) => {
    console.log("🌸 ~ roundRequest ~ jsonObj:", jsonObj);
  });
};
